class AnalyticsService {
    // eslint-disable-next-line class-methods-use-this
    track(category, action, optLabel) {
        let options = {};
        if (optLabel) {
            options = { ...optLabel };
        }
        options.Category = category;

        if (window.mixpanel) {
            window.mixpanel.track(action, options);
        }
    }
}
export default new AnalyticsService();
